import { TagApi } from '@movilizame/networking';
import store from '@/store';

export class MensajesApi {

    constructor (net, list) {
        this.net = new TagApi(net, list);
    }
    /**
     * Listado de mensajes
     * @param {integer} data.viaje_id Filtros de notificaciones
     */
    index (data) {
        return this.net.get('/api/mensajes/index', data);
    }

    /**
     * check de nuevos mensajes
     * @param {integer} data.viaje_id Filtros de notificaciones
     * @param {boolean} data.visto Filtros de notificaciones
     */
    nuevos (data) {
        return this.net.get('/api/mensajes/nuevos', data);
    }

    /**
     *
     */
    getAudio (data) {
        return this.net.get('/api/mensajes/audio', data);
    }

    /**
     * Envia un mensaje
     * @param {integer} data.viaje_id
     * @param {string} data.mensaje
     */
    send (data) {
        return this.net.post('/api/mensajes/enviar', data);
    }

    pendingTrip (data) {
        return this.net.get('/api/mensajes/ultimos', data);
    }

    downloadURL (id) {
        let token = store.getters['auth/token'];
        return process.env.API_URL + '/api/mensajes/audio?id=' + id + '&token=' + token;
    }

    uploadURL (id) {
        let token = store.getters['auth/token'];
        return process.env.API_URL + '/api/mensajes/enviar-audio?&token=' + token;
    }

}



// WEBPACK FOOTER //
// ./src/services/api/MensajesApi.js